/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Modal } from "semantic-ui-react";
import CodeableConceptEntry from "../datatypeComponents/CodeableConceptEntry";
import { sectionCodeResults } from "../dictionaries/CodeSystemLookup";
import ArrayEntry from "../datatypeComponents/ArrayEntry";
import { memo, useCallback, useEffect, useMemo, useState } from "react";
import ReferenceEntry from "../datatypeComponents/ReferenceEntry";
import UnsignedIntEntry from "../datatypeComponents/UnsignedIntEntry";
import QuantityEntry from "../datatypeComponents/QuantityEntry";
import SEVCO, { statisticTypeCodeableConceptSet } from "../dictionaries/SEVCO";
import submitFhirJson from "../functions/submitFhirJsonAPI";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUserApiToken } from "../slices/currentUser/currentUserSlice";
import { selectAllResourceChanges } from "../slices/resourceChangeReport/resourceChangeReportSlice";
import { resourceAdded, resourceUpdated, selectResourceById } from "../slices/resourceCollection/resourceCollectionSlice";
import updateChangeReport from "../slices/resourceChangeReport/updateChangeReport";
import StringEntry from "../datatypeComponents/StringEntry";
import getIdFromReference from "../functions/getIdFromReference";
import { createEvidenceDisplay } from "./CompositionViewer";
import { InitialStatisticEntry } from "./EvidenceResourceEdit";


const AddTableRowModal = ({ resourceLoaded, setOpenAddTableRowModalState, reportType }) => {

  const foi = resourceLoaded.json.id;
  const dispatch = useDispatch();
  const resourceChanges = useSelector(state => selectAllResourceChanges(state));
  const parentResourceDetail = useSelector(state => selectResourceById(state, foi));

  let noGroups = false;
  const groupReferencesDictionary = resourceLoaded.groupReferencesDictionary;
  const groupKeys = Object.keys(groupReferencesDictionary);
  if (!groupKeys || groupKeys.length === 0) {
    noGroups = true;
  }

  const [addTableRowModalState, setAddTableRowModalState] = useState({
    "newRowTitle": "",
    "newRowFocus": ""
  });
  const [groupsState, setGroupsState] = useState({ "groups": [] });
  const [groupKeysState, setGroupKeysState] = useState([]);
  const [groupReferencesDictionaryState, setGroupReferencesDictionaryState] = useState({});

  const submitNewRowChange = () => {
    if (addTableRowModalState.newRowTitle && addTableRowModalState.newRowFocus) {
      let entryArray = [];
      for (let entryKey of Object.keys(addTableRowModalState)) {
        if (entryKey !== "newRowTitle" && entryKey !== "newRowFocus") {
          entryArray.push(JSON.parse(JSON.stringify(addTableRowModalState[entryKey])));
        }
      }
      let newRow = {
        "title": addTableRowModalState.newRowTitle,
        "code": sectionCodeResults,
        "focus": addTableRowModalState.newRowFocus || { "display": "[No data]" },
        "entry": entryArray
      }
      let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
      newResourceDetail.revisedResourceJson.section.push(newRow);
      console.log("resourceUpdate for Composition.section[]");
      dispatch(resourceUpdated(newResourceDetail));
      updateChangeReport(dispatch, resourceChanges, foi,
        "Composition.section",
        "section[" + newResourceDetail.revisedResourceJson.section.length + "]",
        null,
        newRow);
      setOpenAddTableRowModalState(prevState => { return { ...prevState, openModal: false }; });
    }
  }

  useEffect(() => {
    if (groupsState.groups.length > 0) {
      let newGroupKeys = [];
      let newGroupReferencesDictionary = {};
      for (let group of groupsState.groups) {
        let groupId = getIdFromReference(group);
        newGroupKeys.push(groupId);
        newGroupReferencesDictionary[groupId] = group;
      }
      setGroupKeysState(newGroupKeys);
      setGroupReferencesDictionaryState(newGroupReferencesDictionary);
    }
  }, [groupsState])

  let modalContent = <div style={{
    paddingTop: "6px", paddingLeft: "20px", paddingRight: "20px",
    paddingBottom: "40px", width: "100%", height: "100%", overflow: "auto"
  }}>
    <Button style={{ padding: "6px", position: "absolute", right: "14px" }}
      className="formButton negative"
      content="✖"
      onClick={() => {
        setOpenAddTableRowModalState(prevState => { return { ...prevState, openModal: false }; });
      }} />
    <h3>Name the Outcome (how it will show in the table row header)</h3>
    <br />
    <StringEntry elementName='newRowTitle' fieldLabel='Title' required
      startingValue={addTableRowModalState.newRowTitle} setResourceState={setAddTableRowModalState} />
    <br />
    <h3>Set or create the structured Outcome Definition</h3>
    <br />
    {reportType === "Participant Flow" ?
      <ReferenceEntry elementName='newRowFocus' enableCreation={true}
        fieldLabel='ParticipantFlowEvidenceVariable (Resource Reference)' referencedResourceTypes={['EvidenceVariable']}
        startingResourceType="EvidenceVariable" setProfile="ParticipantFlowEvidenceVariable"
        startingValue={addTableRowModalState.newRowFocus} setResourceState={setAddTableRowModalState} />
      :
      <ReferenceEntry elementName='newRowFocus' enableCreation={true}
        fieldLabel='OutcomeDefinition (Resource Reference)' referencedResourceTypes={['EvidenceVariable']}
        startingResourceType="EvidenceVariable" setProfile="VariableDefinition"
        startingValue={addTableRowModalState.newRowFocus} setResourceState={setAddTableRowModalState} />
    }
    {groupKeys.map((groupKey, groupIndex) => {
      return <div key={groupIndex}>
        <br />
        <h3>Set or create the structured Evidence for {groupReferencesDictionary[groupKey].display}</h3>
        <br />
        <ReferenceEntry elementName={groupKey} enableCreation={true}
          fieldLabel='Evidence (Resource Reference)' referencedResourceTypes={['Evidence']}
          startingResourceType="Evidence"
          setProfile={groupReferencesDictionary[groupKey].type === "EvidenceVariable" ? "ComparativeEvidence" : "NonComparativeEvidence"}
          addElementValues={groupReferencesDictionary[groupKey].type === "EvidenceVariable" ?
            {
              variableDefinition: [
                {
                  "description": "Parent Population",
                  "variableRole": "population",
                  "observed": { "display": "Parent Population" }
                },
                {
                  "description": groupReferencesDictionary[groupKey]?.display,
                  "variableRole": "exposure",
                  "observed": groupReferencesDictionary[groupKey]
                },
                {
                  "description": addTableRowModalState.newRowFocus?.display,
                  "variableRole": "outcome",
                  "observed": addTableRowModalState.newRowFocus
                }
              ]
            }
            :
            {
              variableDefinition: [
                {
                  "description": groupReferencesDictionary[groupKey]?.display,
                  "variableRole": "population",
                  "observed": groupReferencesDictionary[groupKey]
                },
                {
                  "description": addTableRowModalState.newRowFocus?.display,
                  "variableRole": "outcome",
                  "observed": addTableRowModalState.newRowFocus
                }
              ]
            }
          }
          startingValue={addTableRowModalState[groupKey]} setResourceState={setAddTableRowModalState} />
      </div>
    })}
    <br /><br /><span>
      <Button style={{ color: "#FFFFFF", width: "230px", float: "left" }} className="formButton"
        content="Submit Changes" positive
        onClick={submitNewRowChange}
        disabled={!addTableRowModalState.newRowTitle || !addTableRowModalState.newRowFocus}
      />
      &nbsp;&nbsp;
      {!addTableRowModalState.newRowTitle && <>Enter a title at the top to submit changes.</>}
      {!addTableRowModalState.newRowFocus && <> Enter a focus (EvidenceVariable reference) at the top to submit changes.</>}
    </span>
    <br />
  </div>;

  if (noGroups) {
    modalContent = <div style={{
      paddingTop: "6px", paddingLeft: "20px", paddingRight: "20px",
      paddingBottom: "40px", width: "100%", height: "100%", overflow: "auto"
    }}>
      <Button style={{ padding: "6px", position: "absolute", right: "14px" }}
        className="formButton negative"
        content="✖"
        onClick={() => {
          setOpenAddTableRowModalState(prevState => { return { ...prevState, openModal: false }; });
        }} />
      <h3>Name the Outcome (how it will show in the table row header)</h3>
      <br />
      <StringEntry elementName='newRowTitle' fieldLabel='Title' required
        startingValue={addTableRowModalState.newRowTitle} setResourceState={setAddTableRowModalState} />
      <br />
      <h3>Set or create the structured Outcome Definition</h3>
      <br />
      {reportType === "Participant Flow" ?
        <ReferenceEntry elementName='newRowFocus' enableCreation={true}
          fieldLabel='ParticipantFlowEvidenceVariable (Resource Reference)' referencedResourceTypes={['EvidenceVariable']}
          startingResourceType="EvidenceVariable" setProfile="ParticipantFlowEvidenceVariable"
          startingValue={addTableRowModalState.newRowFocus} setResourceState={setAddTableRowModalState} />
        :
        <ReferenceEntry elementName='newRowFocus' enableCreation={true}
          fieldLabel='OutcomeDefinition (Resource Reference)' referencedResourceTypes={['EvidenceVariable']}
          startingResourceType="EvidenceVariable" setProfile="VariableDefinition"
          startingValue={addTableRowModalState.newRowFocus} setResourceState={setAddTableRowModalState} />
      }
      <h3>Set or create the structured Group Resources</h3>
      <br />
      <ArrayEntry datatype='Reference' elementName='groups' enableCreation={true}
        fieldLabel='Group (Resource Reference)' referencedResourceTypes={['Group']}
        startingResourceType="Group"
        startingValue={groupsState.groups} setResourceState={setGroupsState} />
      {groupKeysState.map((groupKey, groupIndex) => {
        return <div key={groupIndex}>
          <br />
          <h3>Set or create the structured Evidence for {groupReferencesDictionaryState[groupKey].display}</h3>
          <br />
          <ReferenceEntry elementName={groupKey} enableCreation={true}
            fieldLabel='Evidence (Resource Reference)' referencedResourceTypes={['Evidence']}
            startingResourceType="Evidence"
            setProfile={groupReferencesDictionaryState[groupKey].type === "EvidenceVariable" ? "ComparativeEvidence" : "NonComparativeEvidence"}
            addElementValues={groupReferencesDictionaryState[groupKey].type === "EvidenceVariable" ?
              {
                variableDefinition: [
                  {
                    "description": "Parent Population",
                    "variableRole": "population",
                    "observed": { "display": "Parent Population" }
                  },
                  {
                    "description": groupReferencesDictionaryState[groupKey]?.display,
                    "variableRole": "exposure",
                    "observed": groupReferencesDictionaryState[groupKey]
                  },
                  {
                    "description": addTableRowModalState.newRowFocus?.display,
                    "variableRole": "outcome",
                    "observed": addTableRowModalState.newRowFocus
                  }
                ]
              }
              :
              {
                variableDefinition: [
                  {
                    "description": groupReferencesDictionaryState[groupKey]?.display,
                    "variableRole": "population",
                    "observed": groupReferencesDictionaryState[groupKey]
                  },
                  {
                    "description": addTableRowModalState.newRowFocus?.display,
                    "variableRole": "outcome",
                    "observed": addTableRowModalState.newRowFocus
                  }
                ]
              }
            }
            startingValue={addTableRowModalState[groupKey]} setResourceState={setAddTableRowModalState} />
        </div>
      })}

      <br /><br /><span>
        <Button style={{ color: "#FFFFFF", width: "230px", float: "left" }} className="formButton"
          content="Submit Changes" positive
          onClick={submitNewRowChange}
          disabled={!addTableRowModalState.newRowTitle || !addTableRowModalState.newRowFocus}
        />
        &nbsp;&nbsp;
        {!addTableRowModalState.newRowTitle && <>Enter a title at the top to submit changes.</>}
        {!addTableRowModalState.newRowFocus && <> Enter a focus (EvidenceVariable reference) at the top to submit changes.</>}
      </span>
      <br />
    </div>;
  }

  return (
    <Modal
      style={{ padding: "0px", margin: "0px" }}
      dimmer={<Modal.Dimmer style={{ backgroundColor: "#00000077" }} />}
      open={true}
      centered={false}
      content={modalContent}
    />
  )
}

const SingleEvidenceEntry = memo(({ startingValue, addElementValues,
  statisticType, statisticUnit, setEntryInstanceState, resourceLoaded, knownDataCount }) => {
  let resourceDictionary = resourceLoaded.combinedDictionary;

  const dispatch = useDispatch();

  const calculateStartingEntryValues = useCallback(() => {
    let startingEntryValues = { "statisticType": "", "quantity": "", "knownDataCount": "", "entryInstance": "" };
    if (statisticType) {
      startingEntryValues.statisticType = statisticType;
    }
    if (statisticUnit) {
      startingEntryValues.quantity = { "unit": statisticUnit };
    }
    if (knownDataCount || knownDataCount === 0) {
      startingEntryValues.knownDataCount = knownDataCount;
    }
    if (startingValue) {
      startingEntryValues.entryInstance = startingValue;
      let foi = "";
      if (startingValue.reference) {
        if (startingValue.reference.split("/")[1] && !isNaN(startingValue.reference.split("/")[1])) {
          foi = startingValue.reference.split("/")[1];
        }
      } else if (startingValue.identifier?.system === "https://fevir.net/FLI" &&
        startingValue.identifier.value) {
        let fli = startingValue.identifier.value;
        if (resourceDictionary?.fliToFoi) {
          foi = resourceDictionary["fliToFoi"][fli];
        }
      }
      if (foi && resourceDictionary[foi]) {
        let EvidenceJson = resourceDictionary[foi];
        if (EvidenceJson.statistic?.[0]) {
          if (EvidenceJson.statistic[0].statisticType) {
            startingEntryValues.statisticType = EvidenceJson.statistic[0].statisticType;
          }
          if (EvidenceJson.statistic[0].quantity) {
            startingEntryValues.quantity = EvidenceJson.statistic[0].quantity;
          }
          if (EvidenceJson.statistic[0].sampleSize?.knownDataCount ||
            EvidenceJson.statistic[0].sampleSize?.knownDataCount === 0) {
            startingEntryValues.knownDataCount = EvidenceJson.statistic[0].sampleSize.knownDataCount;
          }
        }
      }
    }
    if (!startingEntryValues.entryInstance && addElementValues?.title) {
      startingEntryValues.entryInstance = { "display": addElementValues.title };
    }
    return startingEntryValues;
  }, [addElementValues.title, knownDataCount, resourceDictionary, startingValue, statisticType, statisticUnit]);
  const startingEntryValues = useMemo(() => calculateStartingEntryValues(), [calculateStartingEntryValues]);

  const calculateStartingEvidenceValues = useCallback(() => {
    let startingEvidenceValues = { "foi": "", "title": "", "statisticType": "", "quantity": "", "knownDataCount": "", "json": "" };
    if (statisticType) {
      startingEvidenceValues.statisticType = statisticType;
    }
    if (statisticUnit) {
      startingEvidenceValues.quantity = { "unit": statisticUnit };
    }
    if (knownDataCount || knownDataCount === 0) {
      startingEvidenceValues.knownDataCount = knownDataCount;
    }
    if (startingValue && startingValue) {
      startingEntryValues.entryInstance = startingValue;
      let foi = "";
      if (startingValue.reference) {
        if (startingValue.reference.split("/")[1] && !isNaN(startingValue.reference.split("/")[1])) {
          foi = startingValue.reference.split("/")[1];
        }
      } else if (startingValue.identifier?.system === "https://fevir.net/FLI" &&
        startingValue.identifier.value) {
        let fli = startingValue.identifier.value;
        if (resourceDictionary?.fliToFoi) {
          foi = resourceDictionary["fliToFoi"][fli];
        }
      }
      if (foi && resourceDictionary[foi]) {
        let EvidenceJson = resourceDictionary[foi];
        startingEvidenceValues.foi = EvidenceJson.id;
        startingEvidenceValues.title = EvidenceJson.title;
        startingEvidenceValues.json = EvidenceJson;
        if (EvidenceJson.statistic?.[0]) {
          if (EvidenceJson.statistic[0].statisticType) {
            startingEvidenceValues.statisticType = EvidenceJson.statistic[0].statisticType;
          }
          if (EvidenceJson.statistic[0].quantity) {
            startingEvidenceValues.quantity = EvidenceJson.statistic[0].quantity;
          }
          if (EvidenceJson.statistic[0].sampleSize?.knownDataCount ||
            EvidenceJson.statistic[0].sampleSize?.knownDataCount === 0) {
            startingEvidenceValues.knownDataCount = EvidenceJson.statistic[0].sampleSize.knownDataCount;
          }
        }
      }
    }
    if (!startingEvidenceValues.title && addElementValues?.title) {
      startingEvidenceValues.title = addElementValues.title;
    }
    return startingEvidenceValues;
  }, [knownDataCount, resourceDictionary, startingEntryValues, startingValue, statisticType, statisticUnit]);
  const startingEvidenceValues = useMemo(() => calculateStartingEvidenceValues(), [calculateStartingEvidenceValues]);


  const [entryState, setEntryState] = useState(JSON.parse(JSON.stringify(startingEntryValues || null)));
  const [evidenceJsonState, setEvidenceJsonState] = useState(JSON.parse(JSON.stringify(startingEvidenceValues || null)));
  const apiToken = useSelector(selectCurrentUserApiToken);

  const createNewReferencedResource = (title, statisticType, quantity, knownDataCount, addElementValues) => {

    let newResource = {
      "resourceType": "Evidence",
      "meta": {},
      "title": title || "[Untitled Evidence]",
      "status": "active",
      "statistic": [{}]
    };

    if (addElementValues) {
      for (const key in addElementValues) {
        if (addElementValues[key]) {
          newResource[key] = addElementValues[key];
          if (!title && key === "title") {
            title = newResource.title;
          }
        }
      }
    }

    if (newResource.statistic) {
      newResource.statistic[0].statisticType = statisticType;
      newResource.statistic[0].quantity = quantity;
      if (newResource.statistic[0].sampleSize) {
        newResource.statistic[0].sampleSize.knownDataCount = knownDataCount;
      } else {
        newResource.statistic[0].sampleSize = { "knownDataCount": knownDataCount };
      }
    } else {
      newResource.statistic = [{
        "statisticType": statisticType, "quantity": quantity,
        "sampleSize": { "knownDataCount": knownDataCount }
      }]
    }
    return newResource;
  };

  const submitAndGetEvidenceResourceValues = async (newResource) => {
    let resourceFOI;
    let response = await submitFhirJson(newResource, newResource.title, apiToken);
    let evidenceResourceValues;
    if (response?.success) {
      resourceFOI = response.formstateid;
      evidenceResourceValues = {
        foi: resourceFOI,
        statisticType: newResource.statistic[0].statisticType,
        quantity: newResource.statistic[0].quantity,
        knownDataCount: newResource.statistic[0].sampleSize.knownDataCount,
        json: newResource
      }
    }
    return evidenceResourceValues;
  }

  const createEvidenceResource = async () => {
    let title = evidenceJsonState?.title || entryState?.entryInstance?.display || "[Untitled evidence]";
    let statisticType = evidenceJsonState.statisticType;
    let quantity = evidenceJsonState.quantity;
    let knownDataCount = evidenceJsonState.knownDataCount;
    let newResource = createNewReferencedResource(title, statisticType, quantity, knownDataCount, addElementValues);

    let evidenceResourceValues = await submitAndGetEvidenceResourceValues(newResource);
    if (evidenceResourceValues?.foi) {

      let resourceFOI = evidenceResourceValues.foi;
      newResource.id = resourceFOI;
      let resourceBody = {
        id: resourceFOI,
        displayTitle: title,
        productFamily: "",
        parentProductFOI: "",
        resourceType: newResource.resourceType,
        resourceJson: newResource,
        revisedResourceJson: newResource
      }
      dispatch(resourceAdded(resourceBody));

      setEvidenceJsonState(evidenceResourceValues);
      setEntryState({
        "statisticType": statisticType, "quantity": quantity, "knownDataCount": knownDataCount,
        "entryInstance": {
          "reference": "Evidence/" + evidenceResourceValues.foi,
          "type": "Evidence",
          "display": title
        }
      });
    } else {
      alert("A problem occurred when creating this Evidence Resource.");
    }
  };

  useEffect(() => {
    if (entryState.entryInstance && startingEntryValues.entryInstance !== entryState.entryInstance) {
      setEntryInstanceState(entryState.entryInstance);
    }
  }, [entryState]);

  return <>
    {evidenceJsonState.foi ?
      <p><b>Summary of Evidence Reource: </b>{createEvidenceDisplay(evidenceJsonState.json)}</p>
      :
      <>
        <p>Click Edit the reference link below to create the Evidence Resource.</p>
      </>}
    <ReferenceEntry elementName='entryInstance' fieldLabel='Reference to this Evidence Resource'
      startingValue={entryState.entryInstance} referencedResourceTypes={["Evidence"]}
      startCollapsed={true} enableCreation={true} inTableCell={true}
      startingResourceType={"Evidence"}
      addElementValues={addElementValues}
      setResourceState={setEntryState} />
  </>
});

const EditTableCellEvidenceOnlyModal = memo(({ setOpenEditModalState,
  entryInstance, setEntryInstanceState, resourceLoaded,
  statisticType, statisticUnit, knownDataCount, addElementValues }) => {

  const submitChange = () => {
    setOpenEditModalState(prevState => { return { ...prevState, openModal: false }; });
  }

  let modalContent = <div style={{
    paddingTop: "6px", paddingLeft: "20px", paddingRight: "20px",
    paddingBottom: "40px", width: "100%", height: "100%", overflow: "auto"
  }}>
    <div>
      <div style={{ textAlign: "center" }}>
        <h3 style={{ paddingLeft: "180px" }} >Edit Table Cell Content</h3>
      </div>
      <Button style={{ color: "#FFFFFF", position: "absolute", top: "6px", width: "180px", float: "left" }}
        className="formButton"
        content="Close Modal" positive
        onClick={submitChange}
      />
      <Button style={{ padding: "6px", position: "absolute", top: "6px", right: "14px" }}
        className="formButton negative"
        content="✖"
        onClick={() => {
          setOpenEditModalState(prevState => { return { ...prevState, openModal: false }; });
        }} />
    </div>
    <br /><br /><br />
    <div style={{ marginLeft: "24px" }}>
      <SingleEvidenceEntry startingValue={entryInstance}
        statisticType={statisticType} statisticUnit={statisticUnit}
        knownDataCount={knownDataCount}
        addElementValues={addElementValues}
        resourceLoaded={resourceLoaded}
        setEntryInstanceState={setEntryInstanceState} />
    </div>
    <br /><br />
    <Button style={{ color: "#FFFFFF", width: "180px", float: "left" }} className="formButton"
      content="Close Modal" positive
      onClick={submitChange}
    />
    <br />
  </div>;

  return (
    <Modal
      style={{ padding: "0px", margin: "0px" }}
      dimmer={<Modal.Dimmer style={{ backgroundColor: "#00000077" }} />}
      open={true}
      centered={false}
      content={modalContent}
    />
  )
});

export { AddTableRowModal, EditTableCellEvidenceOnlyModal };